import { Card, Col, message, Row } from 'antd';
import React, { Component } from 'react';
import { queryBookInfoInfo } from '@api/finance/finance';
import DescriptionList from '@comm/DescriptionList';
import { BackBtn } from '@comm/BackBtn';

const { Description } = DescriptionList;

const typeName = ['一般纳税人', '小规模纳税人'];
class PageOpen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    this.getBookInfoInfo();
  }

  getBookInfoInfo = () => {
    queryBookInfoInfo({
      uuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { data } = this.state;
    return (
      <div className="form-open">
        <Row style={{ paddingBottom: '20px' }}>
          <Col span={13}>
            <BackBtn />
          </Col>
        </Row>
        <Card title="公司账户信息">
          <DescriptionList size="large" col={2}>
            <Description term="公司名称">{data.compName}</Description>
            <Description term="纳税人识别号">{data.taxpayerNumber}</Description>
            <Description term="地址">{data.address}</Description>
            <Description term="电话">{data.telephone}</Description>
            <Description term="开户行">{data.bankName}</Description>
            <Description term="开户账号">{data.bankBook}</Description>
            <Description term="类型">{typeName[data.type]}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}

export default PageOpen;



// WEBPACK FOOTER //
// ./src/components/finance/bookInfo/PageOpen.js